import { useEffect, useState } from 'react';
import { injectIntl, useIntl } from 'react-intl';
import { MasterBlock } from '../MasterBlock';
import { SimpleBar } from '../SimpleBar';
import { inputStyle, noEditableStyle } from '../styles';
import { Table } from '../Table';
import { Row } from '../Table/row';
import PropTypes from '../../../utils/propTypes';

const BatchWidgetRow = injectIntl(
  ({ intl, work, total, element, rowUpdateForm, formValue }) => {
    return (
      <Row
        cells={[
          {
            value: `${intl.formatMessage({ id: 'elements.' + element })}`,
            style: { backgroundColor: '#e6e6e6' },
          },
          {
            html: (
              <input
                type="number"
                min={0}
                value={formValue}
                onChange={({ target: { value } }) =>
                  rowUpdateForm(element, parseInt(value, 10))
                }
                onBlur={() => {
                  if (!formValue) {
                    rowUpdateForm(element, 0);
                  }
                }}
                style={inputStyle}
              ></input>
            ),
            style: {
              width: '10%',
              borderRight: '2px solid #f1f1f1',
              borderTop: '2px solid #f1f1f1',
            },
          },
          {
            value: work,
            style: noEditableStyle,
            textStyle: { color: '#ff0000' },
          },
          {
            value: work - total,
            style: noEditableStyle,
          },
          {
            html: <SimpleBar values={[total, work]} />,
            style: { backgroundColor: '#FFFFFF', border: '0px' },
          },
        ]}
      />
    );
  },
);

const BatchWidget = ({ title, values, updateForm, formValue, elements }) => {
  const intl = useIntl();
  const [total, setTotal] = useState([0, 0]);

  const rowUpdateForm = (key, value) => {
    updateForm({ ...formValue, [key]: value });
  };
  useEffect(() => {
    setTotal([
      elements.reduce(
        (accumulator, element) => accumulator + values.total[element],
        0,
      ),
      elements.reduce(
        (accumulator, element) => accumulator + values.work[element],
        0,
      ),
    ]);
  }, [values.total, elements, values.work]);

  return (
    <MasterBlock title={title} color="#B0B0B0">
      <div className="card-wrapper-table">
        <Table width="100%" style={{ paddingRight: '0px' }}>
          <Row
            cells={[
              {
                value: '',
                style: { backgroundColor: '#FFFFFF', width: '22%' },
              },
              {
                value: `${intl.formatMessage({ id: 'projected' })}`,
                style: { backgroundColor: '#e6e6e6', width: '7%' },
              },
              {
                value: `${intl.formatMessage({ id: 'work' })}`,
                style: { backgroundColor: '#e6e6e6', width: '7%' },
              },
              {
                value: `${intl.formatMessage({ id: 'deviation' })}`,
                style: { backgroundColor: '#e6e6e6', width: '9%' },
              },
              {
                value: '',
                style: { backgroundColor: '#FFFFFF', border: '0px' },
              },
            ]}
          />
          {elements.map((element, index) => (
            <BatchWidgetRow
              key={index}
              work={values.work[element]}
              total={values.total[element]}
              element={element}
              rowUpdateForm={rowUpdateForm}
              formValue={formValue[element]}
            />
          ))}
          <Row
            cells={[
              {
                value: `${intl.formatMessage({ id: 'total.batches' })}`,
                style: { backgroundColor: '#e6e6e6' },
              },
              { value: total[0], style: noEditableStyle },
              {
                value: total[1],
                style: noEditableStyle,
                textStyle: { color: '#ff0000' },
              },
              { value: total[1] - total[0], style: noEditableStyle },
              {
                html: <SimpleBar values={total} />,
                style: { backgroundColor: '#FFFFFF', border: '0px' },
              },
            ]}
          />
        </Table>
      </div>
    </MasterBlock>
  );
};

BatchWidget.propTypes = {
  title: PropTypes.string.isRequired,
  values: PropTypes.shape({ total: PropTypes.object, work: PropTypes.object })
    .isRequired,
  updateForm: PropTypes.func.isRequired,
  formValue: PropTypes.object.isRequired,
  elements: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default BatchWidget;
